const messages = {
    MSG_OLD_BROWSER: 'It looks like you\'re using an outdated browser. For the best experience, please upgrade to a modern browser like Google Chrome (recommended), Microsoft Edge, Firefox, or Safari.',
    MSG_ROLE_BLANK: 'Please choose the teacher\'s permission.',
    MSG_FIRST_NAME_BLANK: 'First name is blank.',
    MSG_LAST_NAME_BLANK: 'Last name is blank.',
    MSG_USERNAME_BLANK: 'Username is blank.',
    MSG_EMAIL_BLANK: 'Email is blank.',
    MSG_PASSWORD_BLANK: 'Password is blank.',
    MSG_LOGIN_INVALID: 'Incorrect username and / or password.',
    MSG_PROMO_BLANK: 'Book code is blank.',
    MSG_CONFIRM_PASSWORD_BLANK: 'Confirm password is blank.',
    MSG_PASSWORDS_DONT_MATCH: 'Passwords do not match.',
    MSG_PIN_BLANK: 'School pin is blank.',
    MSG_CLASS_NAME_BLANK: 'Class name is blank.',
    MSG_SCHOOL_NAME_BLANK: 'School name is blank.',
    MSG_CHANGE_SUPER_ADMIN: 'Are you sure you want to change the super admin?',
    MSG_CONFIRM_SCHOOL: 'Please confirm that you are a student of ', // + :school_nam,
    MSG_CONFIRM_SCHOOL_REJECTED: 'Please check your school pin and try again.',
    MSG_INVALID_PIN: 'Invalid school pin.',
    MSG_JOIN_REQUEST: 'Your request has been sent to the super admin of ', // + :school_nam,
    MSG_STUDENT_JOIN_REQUEST: 'You are now part of ', // + :school_nam,
    MSG_RESULTS_NOT_SAVED: 'Results are only saved if you are logged in.',
    MSG_RESULTS_NOT_SENT: 'Results can only be sent if you are logged in.',
    MSG_RESULTS_UPDATED: 'Results successfully updated.',
    MSG_NO_INTERNET: 'Please check your internet connection.',
    MSG_LOGIN_EXPIRED: 'Login expired, please re-login.',
    MSG_NO_API_CONNECTION: 'Problem connecting to Daydream Education APIs.',
    MSG_EMAIL_LIMIT: 'You have reached your email limit. Please wait and try again.',
    MSG_CONFIRM_DELETE_CLASS: 'Are you sure you want to delete this class? If you continue, the students inside will be moved to no class.',
    MSG_CONFIRM_DELETE_USER: 'Are you sure you want to delete this account? If you continue, the user will no longer be able to access this app, and all data will be deleted.',
    MSG_CONFIRM_DELETE_ME: 'Are you sure you want to delete your account? If you continue, you will no longer be able to access this app, and all data will be deleted.',
    MSG_SUCCESS_DELETE_ME: 'Your account has been deleted.',
    MSG_CONFIRM_DELETE_SUPER_ADMIN: 'You are the super admin of the school. If you delete your account, you will delete the whole school account, including all teachers and all students, plus their results and purchase data. If you do not want to lose this information, you can transfer the super admin role to another teacher. Are you sure you want to continue?',
    MSG_SUCCESS_DELETE_SUPER_ADMIN: 'Your school deletion request has been sent. Once processed, you will receive a confirmation email.',
    MSG_CONFIRM_DOWNLOAD_MOBILE: 'This is a large download, so it is recommended that you connect to WiFi. Select ok to continue or cancel if you want to download later when connected to WiFi.',
    MSG_OFFLINE: 'Connect to the internet to download this content.',
    MSG_GENERIC_400_ERROR: 'Invalid or incomplete data. Please check your input and try again.',
    MSG_PURCHASE_NO_USER: 'Please login and restart app to redeem your purchases.',
    MSG_APP_STORE_ERROR: 'Purchasing is temporarily unavailable. Please try again in a moment.',
    MSG_NO_PRODUCT: 'This item isn’t available right now.',
    MSG_NO_OFFER: 'This item isn’t currently for sale.',
    MSG_PURCHASE_CANCELLED: 'Purchase cancelled.',
    MSG_PURCHASE_FAILED: 'Something went wrong processing your purchase. Please try again.',
    MSG_PURCHASE_SUCCESS: 'Your purchase was successfully added to your account.',
    MSG_PURCHASE_UNVERIFIED: 'We couldn’t confirm your purchase just yet. Please check your connection and try again in a moment.',
    MSG_NOT_LOGGED_IN: 'Please login or create an account first!',
}

export default messages
